// extracted by mini-css-extract-plugin
module.exports = {"HEADER":"header-module--HEADER--328Wm"};